import { gql } from '@apollo/client';

const TICKET_COUNT_AWAITING_UPLOAD_DEVICES_QUERY = gql`
  query countCallCenterStudies($filter: CallCenterStudyFilterInput!) {
    countCallCenterStudies(filter: $filter)
  }
`;

export default TICKET_COUNT_AWAITING_UPLOAD_DEVICES_QUERY;
